import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Tracks a pageview to /api/track/pageview on every route change.
 * Skips /gestione and /api routes (filtered server-side too).
 * Reuses or creates a sessionId in sessionStorage to count unique visitors.
 */
export const PageviewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (path.startsWith("/gestione") || path.startsWith("/api")) return;

    let sessionId = sessionStorage.getItem("pv_session_id");
    if (!sessionId) {
      sessionId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem("pv_session_id", sessionId);
    }

    // Best-effort country detection via browser locale (cheap, no extra request)
    const country = (navigator.language || "").split("-")[1] || "";

    axios
      .post(`${API}/track/pageview`, {
        path,
        referrer: document.referrer || "",
        country,
        session_id: sessionId,
        user_agent: navigator.userAgent || "",
      })
      .catch(() => {});
  }, [location.pathname, location.search]);

  return null;
};
